import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { getErrorMessage } from '../../../utils/helpers/form';
import { getCategories, addCategory, updateCategory, deleteCategory } from '../../../redux/thunks/categories';
import ErrorMessage from '../../../components/error-message/error-message.component';
import CategoryCard from '../../../components/category-card/category-card.component';

const Categories = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    setError,
    clearErrors,
  } = useForm();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { categories, isFetching, isAdding, isUpdating } = useSelector(
    (state) => state.entities.categories
  );

  useEffect(() => {
    dispatch(getCategories({}));
  }, []);

  useEffect(() => {
    watch(() => clearErrors('invalid'));
  }, [watch, clearErrors]);

  const handleAddCategory = (formData) => {
    const { categoryName } = formData;
    if (!categoryName || !categoryName.trim().length) {
      return setError('categoryName', {
        type: 'invalid',
        message: 'יש להזין שם קטגוריה',
      });
    }

    const onSuccess = (message) => {
      enqueueSnackbar(message, { variant: 'success' });
      setValue('categoryName', '');
    };

    const onError = (error) => enqueueSnackbar(error, { variant: 'error' });
    
    dispatch(addCategory({
      name: categoryName.trim(),
      onSuccess,
      onError,
    }));
  };

  const handleUpdateCategory = (id, value) => {
    const onSuccess = (message) => enqueueSnackbar(message, { variant: 'success' });

    const onError = (error) => enqueueSnackbar(error, { variant: 'error' });

    dispatch(updateCategory({
      id,
      name: value,
      onSuccess,
      onError,
    }));
  };

  const handleDeleteCategory = (id) => {
    const onSuccess = (message) => enqueueSnackbar(message, { variant: 'success' });

    const onError = (error) => enqueueSnackbar(error, { variant: 'error' });

    dispatch(deleteCategory({
      id,
      onSuccess,
      onError,
    }));
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <Card>
        <Card.Body>
          <Card.Text
            style={{
              display: 'flex',
              gap: '1rem',
            }}
          >
            <Form.Control
              disabled={isAdding}
              placeholder="קטגוריה"
              type="text"
              {...register('categoryName', { required: true })}
            />
            <Button variant="primary" onClick={handleSubmit(handleAddCategory)}>
              הוסף
            </Button>
            {isAdding && <span>טוען...</span>}
          </Card.Text>
          {errors?.categoryName && (
            <ErrorMessage error={getErrorMessage(errors?.categoryName?.type)} />
          )}
        </Card.Body>
      </Card>

      <Card>
        <Card.Body>
          <Card.Text>
            {isFetching ? (
              <div>טוען...</div>
            ) : (
              <ListGroup variant="flush">
                {categories.length === 0 && 'אין קטגוריות'}
                {categories.map(({ _id, name }) => (
                  <ListGroup.Item key={_id}>
                    <CategoryCard
                      id={_id}
                      value={name}
                      handleSave={handleUpdateCategory}
                      handleDelete={() => handleDeleteCategory(_id)}
                      isUpdating={isUpdating[_id]}
                    />
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Categories;
